import React from 'react';
import { Divider, Link, VisuallyHidden, Text } from '../../..';
import { Facebook, YouTube, LinkedIn, Instagram, Twitter, Tiktok } from '@olxbr/ds-icons';
import * as Styles from './styles';
import { LinksFixo } from '../../utils/links';
import { sendClickEvent } from '../../utils/sendClickEvent';
export const StaticFooter = _ref => {
  let {
    componentName
  } = _ref;
  return React.createElement(React.Fragment, null, React.createElement(Divider, null), React.createElement(Styles.LinksContainer, null, React.createElement(Styles.LegalContainer, {
    "aria-label": "Links comuns"
  }, React.createElement(Styles.LegalContainerLinks, null, LinksFixo.map(props => React.createElement(Link, {
    key: props.name,
    dsParentName: componentName,
    href: props.href,
    variant: "grey",
    size: "small",
    onClick: () => sendClickEvent(props.clickEvent, componentName),
    "data-ds-component": "DS-Footer-Link"
  }, props.name))), React.createElement(Styles.LegalContainerAddress, null, React.createElement(Text.BodySmall, null, "\u00A9 Bom Neg\u00F3cio Atividades de Internet Ltda. - Rua do Catete, 359, Flamengo - 22220-001 - Rio de Janeiro, RJ"))), React.createElement(Styles.SocialContainer, null, React.createElement(Styles.FacebookLink, {
    href: "https://www.facebook.com/olxbrasil",
    variant: "grey",
    onClick: () => sendClickEvent('facebook', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(Facebook, null)), React.createElement(VisuallyHidden, null, "Facebook")), React.createElement(Styles.YouTubeLink, {
    href: "https://www.youtube.com/user/OLXBrasil",
    variant: "grey",
    onClick: () => sendClickEvent('youtube', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(YouTube, null)), React.createElement(VisuallyHidden, null, "Youtube")), React.createElement(Styles.TikTokLink, {
    href: "https://www.tiktok.com/@olx_brasil",
    variant: "grey",
    onClick: () => sendClickEvent('tiktok', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(Tiktok, null)), React.createElement(VisuallyHidden, null, "TikTok")), React.createElement(Styles.InstagramLink, {
    href: "https://instagram.com/olxbr",
    variant: "grey",
    onClick: () => sendClickEvent('instagram', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(Instagram, null)), React.createElement(VisuallyHidden, null, "Instagram")), React.createElement(Styles.TwitterLink, {
    href: "https://twitter.com/olx_Brasil",
    variant: "grey",
    onClick: () => sendClickEvent('twitter', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(Twitter, null)), React.createElement(VisuallyHidden, null, "Twitter")), React.createElement(Styles.LinkedInLink, {
    href: "https://www.linkedin.com/company/olx-brasil",
    variant: "grey",
    onClick: () => sendClickEvent('linkedin', componentName),
    "data-ds-component": "DS-Footer-Link"
  }, React.createElement(Styles.IconWrapper, {
    "aria-hidden": true
  }, React.createElement(LinkedIn, null)), React.createElement(VisuallyHidden, null, "LinkedIn")))));
};
export default StaticFooter;